import { render, staticRenderFns } from "./special-detail.vue?vue&type=template&id=4af987f3&scoped=true"
import script from "./special-detail.vue?vue&type=script&lang=ts"
export * from "./special-detail.vue?vue&type=script&lang=ts"
import style0 from "./special-detail.vue?vue&type=style&index=0&id=4af987f3&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af987f3",
  null
  
)

export default component.exports